import React from 'react';
import { Navigate } from 'react-router-dom';

const getToken = (): string | null => {
    return localStorage.getItem('facit_authToken');
};

const isAuthenticated = (): boolean => {
    const token = getToken();
    // Add any additional validation logic for the token if necessary
    return !!token; // Returns true if token exists, otherwise false
};

interface PrivateRouteProps {
    children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
    return isAuthenticated() ? <>{children}</> : <Navigate to="/auth-pages/login" />;
};

export default PrivateRoute;